<template>
  <div>
    <b-row align-h="center">
      <b-col md="7" sm="12" class="text-left">
        <h3>Statistiques</h3>
        <br />
        <b-row>
          <b-col cols="6" class="mb-4">
            <small class="text-muted mb-0" for="start_date">Début</small>
            <div>{{ statsDlibr.start_date | formatDateTime }}</div>
          </b-col>
          <b-col cols="6" class="mb-4">
            <small class="text-muted mb-0" for="end_date">Fin</small>
            <div>{{ statsDlibr.end_date | formatDateTime }}</div>
          </b-col>
          <b-col cols="6" class="mb-4">
            <small class="text-muted mb-0" for="total_participants">
              Nombre de participants
            </small>
            <div>{{ statsDlibr.total_participants }}</div>
          </b-col>
          <b-col cols="6" class="mb-4">
            <small class="text-muted mb-0" for="group">Nom du groupe</small>
            <div>{{ statsDlibr.group }}</div>
          </b-col>
          <b-col cols="12" class="mb-4">
            <small class="text-muted mb-0" for="nickname">
              Le/la participant(e) le/la plus présent(e)
            </small>
            <div>{{ statsDlibr.most_active_participant[0].nickname }}</div>
          </b-col>
          <b-col cols="12" class="mb-4">
            <small class="text-muted mb-0" for="total_comments">
              Nombre de publications total
            </small>
            <div>{{ statsDlibr.total_comments }}</div>
          </b-col>
          <b-col cols="12" class="mb-4">
            <small class="text-muted mb-0" for="end_date">
              Nombre de publications moyen par participant
            </small>
            <div>
              {{ statsDlibr.average_comments_per_participant.toFixed(2) }}
            </div>
          </b-col>
          <b-col cols="6" class="mb-4">
            <small class="text-muted mb-0" for="end_date">
              Nombre de discussion
            </small>
            <div>{{ statsDlibr.total_discussions }}</div>
          </b-col>
        </b-row>
      </b-col>
      <b-col align-self="center" md="5" sm="12">
        <graph-pie
          :width="500"
          :height="500"
          :padding-top="120"
          :padding-bottom="120"
          :padding-left="120"
          :padding-right="120"
          :values="pieData"
          :names="names"
          :colors="colors"
          :show-text-type="'outside'"
          :data-format="dataFormat"
          :active-index="[0, 1, 2]"
          :renderInterval="0"
        >
        </graph-pie>
      </b-col>
    </b-row>
  </div>
</template>
<script>
/**
 * @file       Deliberation stats graph component.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import store from "@/store";
import { mapState } from "vuex";

/**
 * Export the component.
 * 
 * @type  {Object}
 */
export default {
  name: "statsGraph",

  /**
   * Data used in the component.
   *
   * @return  {Object}
   */
  data() {
    return {
      values: [1, 1, 1],
      names: ["Parce que", "Par contre", "Donc"],
      colors: ["#009966", "#FF6666", "#6666CC"]
    };
  },

  /**
   * Before route change.
   * 
   * @param  {string}   to     Destination
   * @param  {string}   from   (Unused)
   * @param  {Object}   next   The action
   */
  beforeRouteEnter(to, from, next) {
    store
      .dispatch("deliberations/getDlibr", {
        params: { teacher: to.params.teacher, url: to.params.url }
      })
      .then(({ data }) =>
        store
          .dispatch("deliberations/getStatsDlibr", {
            params: { deliberation: data.data.find(d => d).id }
          })
          .then(() => next())
      )
      .catch(() => {
        next(vm => {
          vm.$root.$bvToast.toast(
            "Aucune délibération trouvée pour cette URL",
            {
              title: "Erreur",
              variant: "danger"
            }
          );
          vm.$router.push({ name: "home" });
        });
      });
  },

  /**
   * Computed properties.
   * 
   * @type  {Object}
   */
  computed: {
    ...mapState({
      statsDlibr: state => state.deliberations.statsDlibr.data.data,
      dlibr: state => state.deliberations.dlibr
    }),
    pieData: function() {
      return [
        this.statsDlibr.total_positive_comments,
        this.statsDlibr.total_negative_comments,
        this.statsDlibr.total_neutral_comments
      ];
    }
  },

  /**
   * Methods.
   * 
   * @type  {Object}
   */
  methods: {
    /**
     * Format the data.
     *
     * @param     {String}   k   The type
     * @param     {Bool}     v   The status
     *
     * @return     {String}   The formatted label
     */
    dataFormat: function(k, v) {
      if (v && v != 0) {
        switch (k) {
          case "0":
            return "Parce que (" + v + ")";
          case "1":
            return "Par contre (" + v + ")";
          case "2":
            return "Donc (" + v + ")";
        }
      }
      return null;
    }
  }
};
</script>
<style lang="scss" scoped></style>
